import { findParentNodeClosestToPos } from '@tiptap/core';
import { TIPTAP_COLLAPSIBLE_ITEM_TITLE_TYPE, TIPTAP_COLLAPSIBLE_ITEM_BODY_TYPE, TIPTAP_COLLAPSIBLE_ITEM_TYPE, TIPTAP_COLLAPSIBLE_LIST_TYPE } from 'ricos-content';

const jumpToCollapsibleBody = ({ editor }) => {
  const titleNode = getCollapsibleItemTitle(editor);
  if (!titleNode) {
    return false;
  }
  editor.chain().setTextSelection(titleNode.start + titleNode.node.nodeSize).focus().run();
  return true;
};
const jumpToCollapsibleTitle = (editor, collapsibleItemBody) => {
  if (!collapsibleItemBody)
    return false;
  editor.chain().setTextSelection(collapsibleItemBody.pos - 2).focus().run();
  return true;
};
const deleteListItem = (editor) => {
  const itemNode = getCollapsibleItem(editor);
  if (!itemNode)
    return;
  editor.chain().deleteRange({
    from: itemNode == null ? void 0 : itemNode.pos,
    to: (itemNode == null ? void 0 : itemNode.pos) + (itemNode == null ? void 0 : itemNode.node.nodeSize)
  }).setTextSelection((itemNode == null ? void 0 : itemNode.pos) - 2).run();
};
const getCollapsibleItemBody = (editor) => findParentNodeClosestToPos(
  editor.state.selection.$from,
  (node) => node.type.name === TIPTAP_COLLAPSIBLE_ITEM_BODY_TYPE
);
const getCollapsibleItemTitle = (editor) => findParentNodeClosestToPos(
  editor.state.selection.$from,
  (node) => node.type.name === TIPTAP_COLLAPSIBLE_ITEM_TITLE_TYPE
);
const getCollapsibleItem = (editor) => findParentNodeClosestToPos(
  editor.state.selection.$from,
  (node) => node.type.name === TIPTAP_COLLAPSIBLE_ITEM_TYPE
);
const getCollapsibleList = (editor) => findParentNodeClosestToPos(
  editor.state.selection.$from,
  (node) => node.type.name === TIPTAP_COLLAPSIBLE_LIST_TYPE
);
const keyboardShortcuts = {
  Enter: jumpToCollapsibleBody,
  Tab: jumpToCollapsibleBody,
  Backspace: ({ editor }) => {
    const {
      state: { selection }
    } = editor;
    if (!selection.empty)
      return false;
    const collapsibleItemBody = getCollapsibleItemBody(editor);
    const isAtBodyStart = selection.from - 1 === (collapsibleItemBody == null ? void 0 : collapsibleItemBody.start);
    if (isAtBodyStart) {
      jumpToCollapsibleTitle(editor, collapsibleItemBody);
    } else {
      const titleNode = getCollapsibleItemTitle(editor);
      const isAtTitleStart = selection.from - 1 === (titleNode == null ? void 0 : titleNode.start);
      if (isAtTitleStart) {
        const collapsibleNode = getCollapsibleList(editor);
        const isFirstListItem = (collapsibleNode == null ? void 0 : collapsibleNode.node.firstChild) === getCollapsibleItem(editor);
        if (isFirstListItem)
          return true;
        deleteListItem(editor);
      }
    }
    return false;
  },
  "Shift-Tab": ({ editor }) => jumpToCollapsibleTitle(editor, getCollapsibleItemBody(editor))
};

export { jumpToCollapsibleBody, keyboardShortcuts };
//# sourceMappingURL=keyboardShortcuts.js.map
